<template>
  <div class="vm-block-creator">
    <div class="purple">{{$t('c.BlockCreator.text1')}}</div>
    <div>
      <input type="text" v-model="name" class="gl-input" :placeholder="$t('c.BlockCreator.text2')" />
    </div>
    <div class="mt48 flex-box flex-align-items-end">
      <div class="avatar-upload-box relative">
        <vue-core-image-upload
          v-if="is_client"
          class="gl-upload"
          :crop="false"
          @imageuploaded="avatar_upload"
          @errorhandle="errorhandle"
          text
          :inputOfFile="upload.name"
          :max-file-size="upload.max_file_size"
          :url="upload.avatar_url"
        >
          <i class="afd afd-plus"></i>
          <pic v-if="avatar" class="radius" width="80" height="80" :src="avatar"></pic>
        </vue-core-image-upload>
      </div>
      <div class="fs14 ml24 black-5">{{$t('c.BlockCreator.text3')}}</div>
    </div>
    <div class="line-split mt48"></div>
    <div class="purple mt48">{{$t('c.BlockCreator.text4')}}</div>
    <div>
      <input type="text" class="gl-input" v-model="doing" :placeholder="$t('c.BlockCreator.text5')" />
    </div>
    <div class="purple mt48">{{$t('c.BlockCreator.text6')}}</div>
    <div class="flex-box flex-align-items-baseline">
      <div>{{ host }}/a/</div>
      <input type="text" v-model="url_slug" class="gl-input" :placeholder="$t('c.BlockCreator.text7')" />
    </div>
    <div class="purple mt48">{{$t('c.BlockCreator.text8')}}</div>
    <div>
      <multiselect
        class="mt16"
        v-model="category_item"
        :allowEmpty="false"
        :options="category_list"
        track-by="name"
        label="name"
        :searchable="false"
        :show-labels="false"
        :placeholder="$t('c.BlockCreator.text9')"
      ></multiselect>
    </div>
    <div class="purple mt48">{{$t('c.BlockCreator.text10')}}</div>
    <div>
      <multiselect
        class="mt16"
        v-model="type_item"
        :allowEmpty="false"
        :value="{ type: 1 }"
        :options="create_type"
        track-by="name"
        label="name"
        :searchable="false"
        :show-labels="false"
        :placeholder="$t('c.BlockCreator.text11')"
      ></multiselect>
    </div>
    <div class="purple mt48">{{$t('c.BlockCreator.text12')}}</div>
    <textarea-autosize
      class="gl-textarea mt16"
      :placeholder="$t('c.BlockCreator.text13')"
      v-model="detail"
      :min-height="180"
      :max-height="180"
    ></textarea-autosize>
    <div class="purple mt48">{{$t('c.BlockCreator.text14')}}</div>
    <div class="img-box mt16 flex-wrap">
      <div
        class="img-pre-box darkbg"
        v-if="cover"
        :style="{
                    backgroundImage: `url(${$img_src({
                        src: cover,
                        width: 640,
                        height: 171,
                    })})`,
                }"
      >
        <!-- <pic width="640" height="171" :src="cover"></pic> -->
      </div>
      <btn
        v-if="!cover"
        class="upload-banner flex-align-self-end"
        :text="`<div class='text-center'>${$t('c.BlockCreator.text15')}<br/><br/> ${$t('c.BlockCreator.text16')}</div>`"
      >
        <vue-core-image-upload
          v-if="is_client"
          class="gl-upload"
          :crop="false"
          @imageuploaded="image_upload"
          @errorhandle="errorhandle"
          text
          :inputOfFile="upload.name"
          :max-file-size="upload.max_file_size"
          :url="upload.img_common_url"
        ></vue-core-image-upload>
      </btn>
      <btn v-else class="flex-align-self-end look1 mt16" @click.native="remove_pic">{{$t('c.BlockCreator.text17')}}</btn>
    </div>
    <template v-if="is_creator && !is_apply && session_user && session_user.is_verified == 1 && session_user.is_not_rec != 1">
        <div class="purple mt-48-32 mq">{{$t('c.BlockCreator.text18')}}</div>
        <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
          <div>{{$t('c.BlockCreator.text19')}}</div>
          <switches theme="custom" color="purple" v-model="is_show_income"></switches>
        </div>
         <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
          <div>{{$t('c.BlockCreator.text20')}}</div>
          <switches theme="custom" color="purple" v-model="is_show_sponsor"></switches>
        </div>
      </template>
    <template v-if="is_creator && !is_apply">
      <div class="purple mt48">{{$t('c.BlockCreator.text21')}}</div>
      <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
        <div>{{$t('c.BlockCreator.text22')}}</div>
        <switches theme="custom" color="purple" v-model="show_album"></switches>
      </div>
      <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
        <div>{{$t('c.BlockCreator.text23')}}</div>
        <switches theme="custom" color="purple" v-model="show_shop"></switches>
      </div>
      <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
        <div>{{$t('c.BlockCreator.text36')}}</div>
        <switches theme="custom" color="purple" v-model="show_sponsor_list"></switches>
      </div>
      <div class="mt8 flex-box flex-justify-content-space-between flex-align-items-center">
        <div class="flex-item-3">{{$t('c.BlockCreator.text24')}}</div>
        <multiselect
                class="flex-item-2"
                v-model="show_product_count_item"
                :allowEmpty="false"
                :value="{ type: 1 }"
                :options="show_product_count"
                track-by="name"
                label="name"
                :searchable="false"
                :show-labels="false"
                :placeholder="$t('c.BlockCreator.text25')"
        ></multiselect>
      </div>
      <div class="purple mt48">{{$t('c.BlockCreator.text26')}}</div>
      <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
        <div>{{$t('c.BlockCreator.text27')}}</div>
        <switches theme="custom" color="purple" v-model="no_copy_text"></switches>
      </div>
      <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center">
        <div>{{$t('c.BlockCreator.text28')}}</div>
        <switches theme="custom" color="purple" v-model="no_copy_pic"></switches>
      </div>
        <div class="mt8 flex-box flex-justify-content-space-between flex-align-items-center">
            <div class="flex-item-3">{{$t('c.BlockCreator.text29')}}</div>
            <multiselect
                    class="flex-item-2"
                    v-model="watermark_item"
                    :allowEmpty="false"
                    :value="{ type: 1 }"
                    :options="watermark_type"
                    track-by="name"
                    label="name"
                    :searchable="false"
                    :show-labels="false"
                    :placeholder="$t('c.BlockCreator.text30')"
            ></multiselect>
        </div>
    </template>
    <div class="flex-box mt48">
      <btn :text="btn_text" class="size48 mq" @click.native="submit"></btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
    POST_EDIT_BASIC,GET_SESSION_USER,
    POST_SHOW_PRODUCT_COUNT_SET,
    POST_CREATOR_SHOW_ALBUM,
    POST_CREATOR_SHOW_SHOP,
    POST_CREATOR_SET_SHOW_SPONSOR,
    POST_CREATOR_COPY_TEXT,
    POST_CREATOR_COPY_PIC,
    POST_CREATOR_PRIVACY_PUBLIC_INCOME,
    POST_CREATOR_PRIVACY_PUBLIC_SPONSOR
} from '@/api/config';

export default {
  props: {
    btn_text: {
      default() {
        return '保存';
      },
    },
  },
  data() {
    return {
      value: '',
      options: [],
      cover: '',
      category_item: '',
      type_item: '',
      watermark_item:'',
    //   show_product_count_item: { value: -1, name: "不限" },
      show_product_count_item: '',
      doing: '',
      detail: '',
      name: this.mp_profile ? this.mp_profile.nickname : '',
      avatar: this.mp_profile ? this.mp_profile.headimgurl : '',
      url_slug: '',
      show_album: '',
      show_shop:'',
      show_sponsor_list:'',
      no_copy_text: '',
      no_copy_pic: '',
      is_show_income: "",
      is_show_sponsor:'',
      watermark_type: [
          { type: 1, name: this.$t('c.BlockCreator.text31') },
          { type: 2, name: this.$t('c.BlockCreator.text32') },
          { type: 3, name: this.$t('c.BlockCreator.text33') },
      ],
      create_type:[
        { type: 1, name: this.$t('c.BlockCreator.text34') },
        { type: 2, name: this.$t('c.BlockCreator.text35') },
      ]
    };
  },
  watch: {
    show_album(newValue, oldValue) {
      if (oldValue !== '') {
        this.setting_album(newValue ? 1 : 0);
      }
    },
    show_shop(newValue, oldValue) {
      if (oldValue !== '') {
        this.setting_shop(newValue ? 1 : 0);
      }
    },
    show_sponsor_list(newValue, oldValue) {
      if (oldValue !== '') {
        this.setting_sponsor_list(newValue ? 1 : 0);
      }
    },
    no_copy_text(newValue, oldValue) {
      if (oldValue !== '') {
        this.setting_copy_text(newValue ? 0 : 1);
      }
    },
    no_copy_pic(newValue, oldValue) {
      if (oldValue !== '') {
        this.setting_copy_pic(newValue ? 0 : 1);
      }
    },
    is_show_income(newValue, oldValue) {
      if (oldValue !== "") {
        this.setting_income(newValue ? 1 : 0);
      }
    },
    is_show_sponsor(newValue, oldValue) {
      if (oldValue !== "") {
        this.setting_sponsor(newValue ? 1 : 0);
      }
    },
    show_product_count_item(newValue, oldValue){
      if (oldValue !== "") {
        this.setting_shop_count(newValue.value);
      }
    },
    watermark_item(newValue, oldValue){
      if (oldValue !== "") {
        this.submit();
      }
    }

  },
  computed: {
    ...mapState('app', [
      'session_user',
      'mp_profile',
      'is_client',
      'upload',
      'category_list',
      // 'create_type',
      'host',
      'user_status',
    ]),
    ...mapState('order', [
      'show_product_count',
    ]),
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    },
    is_apply(){
        return this.$route && this.$route.name == 'apply'
    },
    tit() {
      if (!this.is_creator) {
        return '成为创作者';
      }
      return '设置';
    },
    post_data() {
      return {
        doing: this.doing,
        avatar: this.avatar,
        name: this.name,
        category_id: this.category_item.category_id,
        type: this.type_item.type,
        watermark: this.watermark_item.type,
        detail: this.detail,
        url_slug: this.url_slug,
        cover: this.cover,
      };
    },
  },
  components: {},
  async mounted() {
    await this.$store.dispatch('app/get:category_list');
    await this.$store.dispatch('app/set:session_user');
    let re = await this.$mixin_waitting_api(GET_SESSION_USER)
    if(re){
        this.init_form();
    }
    // this.$nextTick(() => {

    //   if (this.session_user) {
    //   console.log(222)

    //     this.init_form();
    //   }
    //   console.log(1111)
    // });
  },
  methods: {
    async save() {
      if (this.$http.is_run(POST_EDIT_BASIC)) {
        return false;
      }
      let data = await this.$http.$axios(POST_EDIT_BASIC, this.post_data);

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
      }
      if (this.is_creator && data.ec == 200) {
        this.$notify({
          title: data.em,
          group: 'success',
        });
      }

      if (data.ec == 200) {
        this.$emit('save');
      }
      return data.ec == 200;
    },
    async submit() {
      let result = await this.save();
      if (result) {
        this.$store.dispatch('app/set:session_user');
      }
    },
    avatar_upload(data) {
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
      }
      this.avatar = data.data.url;
    },
    image_upload(data) {
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
      }
      this.cover = data.data.url;
    },
    errorhandle(err_text) {
      if (/FILE IS TOO LARGER MAX FILE/.test(err_text)) {
        err_text = `上传文件最大为: ` + err_text.split(' ').pop();
      }
      this.$notify({
        title: err_text,
        group: 'error',
      });
    },
    remove_pic() {
      this.cover = '';
    },
    remove_sponsor(i) {
      this.sponsor_card_list.splice(i, 1);
    },
    async setting_shop_count(count) {
      if (this.$http.is_run(POST_SHOW_PRODUCT_COUNT_SET)) {
        return false;
      }
      let data = await this.$http.$axios(POST_SHOW_PRODUCT_COUNT_SET, {
        count
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? 'error' : 'success',
      });
      this.session_user.creator.limit_show_product_count = count;
    },
    async setting_album(is_show) {
      if (this.$http.is_run(POST_CREATOR_SHOW_ALBUM)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_SHOW_ALBUM, {
        status: is_show,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? 'error' : 'success',
      });
      this.session_user.creator.show_album = is_show;
    },
    async setting_shop(is_show) {
      if (this.$http.is_run(POST_CREATOR_SHOW_SHOP)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_SHOW_SHOP, {
        status: is_show,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? 'error' : 'success',
      });
      this.session_user.creator.show_shop = is_show;
    },
    async setting_sponsor_list(is_show) {
      if (this.$http.is_run(POST_CREATOR_SET_SHOW_SPONSOR)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_SET_SHOW_SPONSOR, {
        status: is_show,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? 'error' : 'success',
      });
      this.session_user.creator.show_sponsor_list = is_show;
    },
    async setting_income(is_show) {
      if (this.$http.is_run(POST_CREATOR_PRIVACY_PUBLIC_INCOME)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_PRIVACY_PUBLIC_INCOME, {
        status: is_show,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? "error" : "success",
      });
      this.session_user.creator.privacy_public_income = is_show;
    },
    async setting_sponsor(is_show) {
      if (this.$http.is_run(POST_CREATOR_PRIVACY_PUBLIC_SPONSOR)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_PRIVACY_PUBLIC_SPONSOR, {
        status: is_show,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? "error" : "success",
      });
      this.session_user.creator.privacy_public_sponsor = is_show;
    },
    async setting_copy_text(status) {
      if (this.$http.is_run(POST_CREATOR_COPY_TEXT)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_COPY_TEXT, {
        status: status,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? 'error' : 'success',
      });
      this.session_user.creator.can_copy_text = status;
    },
    async setting_copy_pic(status) {
      if (this.$http.is_run(POST_CREATOR_COPY_PIC)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_COPY_PIC, {
        status: status,
      });
      this.$notify({
        title: data.em,
        group: data.ec != 200 ? 'error' : 'success',
      });
      this.session_user.creator.can_copy_pic = status;
    },
    init_form() {
      let self = this.session_user;
      let type = self.creator.type;
      let watermark = self.creator.watermark;
      let category_id = self.creator.category_id;

      this.doing = self.creator.doing;
      this.avatar = self.avatar;
      this.name = self.name;
      this.url_slug = self.url_slug;
      this.detail = self.creator.detail;
      this.cover = self.cover;
      this.show_album = self.creator.show_album;
      this.show_shop = self.creator.show_shop;
      this.show_sponsor_list = self.creator.show_sponsor_list;
      this.no_copy_text = self.creator.can_copy_text ? false : true;
      this.no_copy_pic = self.creator.can_copy_pic ? false : true;

      this.is_show_income = self.creator.privacy_public_income ? true : false;
      this.is_show_sponsor = self.creator.privacy_public_sponsor ? true : false;;

      if (type) {
        this.type_item = {
          type: type,
          name: this.create_type.filter((v, k) => v.type == type)[0].name,
        };
      }
      if (watermark) {
        this.watermark_item = {
          type: watermark,
          name: this.watermark_type.filter((v, k) => v.type == watermark)[0].name,
        };
      }
      if (category_id) {
        this.category_item = {
          category_id: category_id,
          name: this.category_list.filter(
            (v, k) => v.category_id == category_id
          )[0].name,
        };
      }

      if(this.session_user && this.session_user.creator){
        this.show_product_count.forEach(v => {
            if(v.value == this.session_user.creator.limit_show_product_count){
                this.show_product_count_item = v;
            }
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-block-creator {
  .avatar-upload-box {
    width: px2rem(80);
    height: px2rem(80);
    background: $black-1;
    border-radius: 9999px;
  }

  .img-box {
    display: flex;
  }

  .img-pre-box {
    width: 100%;
    height: px2rem(171);
    background-size: cover;
    background-position: center;
  }

  .upload-banner {
    width: 100%;
    background: $black-05;
    color: $black-5;
    height: 175px;
    white-space: pre-wrap;
    line-height: 1.4;

    &:hover {
      background: $black-03;
    }
  }

  .line-split {
    height: px2rem(4);
    width: px2rem(80);
    background: $purple;
  }

  @media (max-width: $width-mobile) {
    .img-box {
      display: block;
    }

    .img-pre-box {
      margin-right: 0;
      margin-bottom: px2rem(16);
      width: 100%;
      // height: auto;
    }
    .upload-banner {
        height: 182px;
    }
  }
}
</style>
